import { useEffect, useState } from 'react';

import APIHandler from 'config/APIHandler';

import { useUserInfo } from 'hooks/useUserInfo';

const useIncentiveLink = (microAppId) => {
  const {
    user: { email },
  } = useUserInfo();
  const [incentiveLink, setIncentiveLink] = useState('');
  const [incentiveProgress, setIncentiveProgress] = useState(0);

  useEffect(() => {
    if (microAppId > 0) {
      const generateIncentiveLink = async () => {
        const { data } = await APIHandler.getUserProgress(microAppId, email);
        if (data) {
          const chapterData = data[0].chapters[0];
          const { chapter, progress, total_pages: totalPages } = chapterData;
          const page = progress < totalPages - 1 ? progress : 0;

          const p = Math.round((progress / (totalPages - 1)) * 100, 0);
          setIncentiveProgress(p);

          let pType = 'training';
          if (p >= 100) {
            pType = 'retain';
          }

          const link = `https://academy.travpromobile.com/${pType}/${microAppId}/${email}/${chapter}/${page}/true/true/?redirurl=${window.location.href}`;
          setIncentiveLink(link);
        }
      };

      try {
        generateIncentiveLink();
      } catch (error) {
        setIncentiveLink('');
      }
    }
  }, [microAppId, email]);

  return [incentiveLink, incentiveProgress];
};

export default useIncentiveLink;
